import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AudiencedDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json; charset=UTF-8'
    })
  };

  constructor( private http: HttpClient ) { }

  public getCapacity(context, lang, udid, datetimeFrom, datetimeTo, centerInternalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const items = { datetimeFrom, datetimeTo, centerInternalIds };
    options['params'] = items;
    return this.http.get(this.BASE_URL + 'private/v2.0/dashboard/statistics/peopleCounter', options);
  }

  public getWifiStats(context, lang, udid, datetimeFrom, datetimeTo, centerInternalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const items = { datetimeFrom, datetimeTo, centerInternalIds };
    options['params'] = items;
    return this.http.get(this.BASE_URL + 'private/v2.0/dashboard/wifi/stats', options);
  }

  public getTrafficUrl(context, lang, udid, centerInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const items = { centerInternalId };
    options['params'] = items;
    return this.http.get(this.BASE_URL + 'private/v2.0/dashboard/traffic/url', options);
  }

}
